import React from 'react';
import TopBar from '../../../../elements/TopBar/TopBar';

export default class Header extends React.PureComponent {
    render() {
        let {i18n}  = this.props;
        return <div>
                <TopBar returnURL="..">{i18n['label.delete.data']}</TopBar>
                <hr/>
                <div className="content">
                    <br/>
                    <p className="text">{i18n['label.delete.typeofdata']}</p>
                    <br/>
                </div>
                <hr />
            </div>;
    }
}
